var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filterWrapper geoFilter" },
    [
      _c("v-select", {
        ref: "select",
        attrs: {
          getOptionKey: _vm.getOptionKey,
          filterBy: _vm.filterBy,
          options: _vm.paginated,
          placeholder: _vm.name,
          filterable: false,
        },
        on: {
          open: _vm.onOpen,
          close: _vm.onClose,
          search: function (query) {
            return (_vm.search = query)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "open-indicator",
            fn: function (ref) {
              var attributes = ref.attributes
              return [
                _c("span", _vm._b({}, "span", attributes, false), [
                  _c("i", {
                    staticClass: "open-indicator",
                    attrs: { role: "presentation" },
                  }),
                ]),
              ]
            },
          },
          {
            key: "no-options",
            fn: function (ref) {
              var search = ref.search
              var searching = ref.searching
              var loading = ref.loading
              return [_vm._v("\n      " + _vm._s(_vm.notFoundLabel) + "\n    ")]
            },
          },
          {
            key: "option",
            fn: function (option) {
              return [
                _c("span", { class: option.class }, [
                  _vm._v(_vm._s(option.label)),
                ]),
              ]
            },
          },
          {
            key: "selected-option",
            fn: function (option) {
              return [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
            },
          },
          {
            key: "list-footer",
            fn: function () {
              return [
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasNextPage,
                        expression: "hasNextPage",
                      },
                    ],
                    ref: "load",
                    staticClass: "loader",
                  },
                  [_vm._v("\n        +\n      ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.currentPlace,
          callback: function ($$v) {
            _vm.currentPlace = $$v
          },
          expression: "currentPlace",
        },
      }),
      _vm.distanceExtend && _vm.currentPlace
        ? _c("v-select", {
            staticClass: "distanceExtend",
            attrs: { options: _vm.distanceExtend, searchable: false },
            scopedSlots: _vm._u(
              [
                {
                  key: "selected-option",
                  fn: function (option) {
                    return [
                      _vm._v(
                        "\n      Rayon : " + _vm._s(option.label) + "km\n    "
                      ),
                    ]
                  },
                },
                {
                  key: "option",
                  fn: function (option) {
                    return [
                      _vm._v("\n      " + _vm._s(option.label) + "km\n    "),
                    ]
                  },
                },
              ],
              null,
              false,
              817603164
            ),
            model: {
              value: _vm.distance,
              callback: function ($$v) {
                _vm.distance = $$v
              },
              expression: "distance",
            },
          })
        : _vm._e(),
      _vm.currentPlace
        ? _c("span", { staticClass: "nbChecked absolute" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }